import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useNotificationService } from 'src/features/notificationService/useNotificationService'
import { updateTemplateNodeMultipleChoice } from 'src/state/ducks/templates/actions'
import { extractHttpErrorMessages } from 'src/state/middleware/saga/handleHttpError'
import {
  UpdateMultipleChoicesParams,
  useMutationUpdateMultipleChoices,
} from '../api/useMutationUpdateMultipleChoices'

export const useUpdateMultipleChoices = () => {
  const { showNotification } = useNotificationService()
  const dispatch = useDispatch()
  const { mutate, isPending } = useMutationUpdateMultipleChoices()

  const updateMultipleChoices = useCallback(
    (params: UpdateMultipleChoicesParams, onSuccess: () => void) => {
      mutate(params, {
        onSuccess: updatedChoices => {
          // テンプレートノードの選択肢を更新し、条件分岐の整合性を保つ
          dispatch(
            updateTemplateNodeMultipleChoice(
              params.multipleChoiceId,
              updatedChoices,
            ),
          )
          onSuccess()
        },
        onError: (e: unknown) => {
          showNotification('選択肢の更新に失敗しました', {
            notificationType: 'error',
            duration: 5,
            description: extractHttpErrorMessages(e),
          })
        },
      })
    },
    [mutate, showNotification, dispatch],
  )

  return {
    updateMultipleChoices,
    isPendingUpdateMultipleChoices: isPending,
  }
}
